module.exports = __webpack_public_path__ + "static/media/rc-clinical-trials-icon.ed312121.svg";